import React, { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { consumePostLoginTarget } from '../utils/authRedirect';

/**
 * Ide érkezik a felhasználó minden sikeres bejelentkezés / regisztráció után (e-mail, Google, Facebook stb.).
 * Továbbviszi az előző oldalra, vagy ha az nincs / főoldal, a /profile oldalra.
 */
const AfterLogin: React.FC = () => {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoaded) return;
    if (isSignedIn) {
      navigate(consumePostLoginTarget(), { replace: true });
    } else {
      // nem sikerült a belépés: vissza a főoldalra
      navigate('/', { replace: true });
    }
  }, [isLoaded, isSignedIn, navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
      <CircularProgress />
      <Typography variant="body1">Bejelentkezés…</Typography>
    </Box>
  );
};

export default AfterLogin;